import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';


// Service
import AuthService from "../../services/Auth.User.service";
const initialState = {};

export const fetchUser = createAsyncThunk(
  "users/fetchUser",
  async () => {
    const response = await AuthService.getUser();
    return response.data;
  }
);

export const postWebSetting = createAsyncThunk(
  'userMyProfile/postWebSetting',
  async (data, { rejectWithValue }) => {
    const response = await AuthService.postWebSetting(data);

    if (response.error) {
      return rejectWithValue(response.error.code);
    }

    return response.data;
  }
)

export const putUser = createAsyncThunk(
  'userMyProfile/putUser',
  async (data, thunkAPI) => {
    const response = await AuthService.putUser(data);
    if (response.error) {
      return thunkAPI.rejectWithValue(response.error.code);
    }

    return response.data;
  }
)

export const putPassword = createAsyncThunk(
  'userMyProfile/putPassword',
  async (data, { rejectWithValue }) => {
    const response = await AuthService.putPassword(data);

    if (response.error) {
      return rejectWithValue(response.error.code);
    }

    return response.data;
  }
)

export const postVerify = createAsyncThunk(
  'userMyProfile/postVerify',
  async (data, { rejectWithValue }) => {
    const response = await AuthService.postVerify(data);

    if (response.error) {
      return rejectWithValue(response.error.code);
    }

    return response.data;
  }
);

export const getTwoFAGoogleQR = createAsyncThunk(
  'userMyProfile/getTwoFAGoogleQR',
  async () => {
    try {
      const response = await AuthService.getTwoFAGoogleQR();
      return response.data;
    } catch (err) {
    }
  }
);

export const sendEmail = createAsyncThunk(
  'userMyProfile/sendEmail',
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.sendEmail();

      if (response.error) {
        return rejectWithValue(response.error.code);
      }

      return response.data;
    } catch (err) {
    }
  }
);

export const postUploadPhoto = createAsyncThunk(
  'userMyProfile/postUploadPhoto',
  async (file, { rejectWithValue }) => {
    try {
      const response = await AuthService.postUploadPhoto(file);

      if (response.error) {
        return rejectWithValue(response.error.code);
      }

      return response.data;
    } catch (err) {
    }
  }
);

export const deleteUploadPhoto = createAsyncThunk(
  'userMyProfile/deleteUploadPhoto',
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthService.deleteUploadPhoto();

      if (response.error) {
        return rejectWithValue(response.error.code);
      }

      return response.data;
    } catch (err) {
    }
  }
);

export const postDeleteAccount = createAsyncThunk(
  'userMyProfile/postDeleteAccount',
  async (data, thunkAPI) => {
    try {
      const response = await AuthService.deleteAccount(data);

      if (response.error) {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {
    }
  }
);

const userMyProfileSlice = createSlice({
  name: 'userMyProfile',
  initialState,
  reducers: {
    setInitData(state, action) {
      state.userMyProfile = action.payload;
    },
    changeWebSetting(state, action) {
      state.userMyProfile.webSetting = action.payload;
    },
    initVerifyValue(state, action) {
      if (action.payload) {
        delete state.userMyProfile.verifySuccess;
      }
    },
  },
  extraReducers: {
    [fetchUser.fulfilled]: (state, action) => {
      state.user = action.payload;
    },
    [postVerify.fulfilled]: (state) => {
      state.userMyProfile.verifySuccess = true;
    },
    [postVerify.rejected]: (state) => {
      state.userMyProfile.verifySuccess = false;
    },
    [getTwoFAGoogleQR.fulfilled]: (state, action) => {
      state.userMyProfile.QRData = action.payload;
    }
  }
});

// export const userMyProfileActions = userMyProfileSlice.actions;
export const { setInitData, changeWebSetting, initVerifyValue } = userMyProfileSlice.actions;

export default userMyProfileSlice;